import "../../index53.css";
import { jsx as p } from "react/jsx-runtime";
import c from "react";
import { a as l } from "../../core-DVmjA3_O.js";
import { _ as f } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
const _ = "_raw-input_1iznz_1", d = {
  rawInput: _
};
function R(r) {
  const {
    className: o,
    onChange: a,
    elementRef: s,
    value: i,
    name: t,
    ...m
  } = r, u = c.useCallback((e) => {
    const n = e.currentTarget.value;
    a && a(
      n === "" ? void 0 : n,
      t,
      e
    );
  }, [t, a]);
  return /* @__PURE__ */ p(
    "input",
    {
      ...m,
      ref: s,
      className: f(
        d.rawInput,
        o
      ),
      name: l(t) ? String(t) : void 0,
      onChange: u,
      value: i ?? ""
    }
  );
}
export {
  R as default
};
